import React, { useEffect, useState } from 'react'
import Table from 'react-bootstrap/Table'
import { Link } from 'react-router-dom'
//import { useTabelaGestao } from '../context/GestaoPendenciasContext'
import moment from 'moment'
import api from '../components/api'
import { useEnunciadoContext } from '../context/enunciadoContext'
import { useVerificaDesafioContext } from '../context/verificaDesafioContext'
import { useSecaoEnunciadoContext } from '../context/secaoEnunciadoContext'

import StatusValidacaoSecao from './StatusValidacaoSecao'

const DadosGestao = (props) => {

    var ano = props.ano
    
    var adesao_institucional_id = props.adesao_institucional_id
    var formulario_id = props.formulario_id

    //var { atualizacaoGestao, setAtualizacaoGestao } = useTabelaGestao()

    var [residuo_id, setResiduo_id] = useState()

    var { enunciado, setEnunciado } = useEnunciadoContext()
    var { setSecaoEnunciado } = useSecaoEnunciadoContext()
    var { verificaDesafio } = useVerificaDesafioContext()

    

    const [questao1, setQuestao1] = useState()
    const [questao2, setQuestao2] = useState()
    const [questao3, setQuestao3] = useState()
    const [questao4, setQuestao4] = useState()
    const [questao5, setQuestao5] = useState()
    const [questao6, setQuestao6] = useState()
    const [questao7, setQuestao7] = useState()
    const [questao8, setQuestao8] = useState()
    const [questao9, setQuestao9] = useState()
    const [questao10, setQuestao10] = useState()
    const [questao11, setQuestao11] = useState()

    const [totalPendencias, setTotalPendencias] = useState(0)


    //var [adesao_institucional_id, setAdesaoInstitucionalId] = useState(sessionStorage.getItem('adesao_institucional_id'))

    var [informacoesAdicionais, setInformacoesAdicionais] = useState('')
    var [possuiComiteResiduos, setPossuiComiteResiduos] = useState(false)
    var [frequenciaReunioes, setFrequenciaReunioes] = useState('')
    var [responsavelGerenciamento, setResponsavelGerenciamento] = useState('')
    var [responsavelGerenciamentoTrabalha, setResponsavelGerenciamentoTrabalha] = useState('')

    var [destinoReciclaveisSecos, setDestinoReciclaveisSecos] = useState('')
    var [destinoReciclaveisUmidos, setDestinoReciclaveisUmidos] = useState('')
    var [destinoSubgrupoA4, setDestinoSubgrupoA4] = useState('')
    var [auditoriaEmpresaColetaExterna, setAuditoriaEmpresaColetaExterna] = useState('')
    
    var [calculadoPercentual, setCalculadoPercentual] = useState(false)
    

    var [percPapel, setPercPapel] = useState()
    var [percTexteis, setPercTexteis] = useState()
    var [percAlimento, setPercAlimento] = useState()
    var [percMadeira, setPercMadeira] = useState()
    var [percJardim, setPercJardim] = useState()
    var [percFralda, setPercFralda] = useState()
    var [percBorrachaCouro, setPercBorrachaCouro] = useState()
    var [percLodoEsgoto, setPercLodoEsgoto] = useState()
    var [percOutros, setPercOutros] = useState()
    var [percVarGerResid, setPercVarGerResid] = useState()
    var [percVarGerGrupoA, setPercVarGerGrupoA] = useState()
    var [percVarGerGrupoA, setPercVarGerGrupoA] = useState()
    var [percVarGerGrupoB, setPercVarGerGrupoB] = useState()
    var [percVarGerGrupoD, setPercVarGerGrupoD] = useState()
    var [percVarGerGrupoE, setPercVarGerGrupoE] = useState()
    var [percVarPercReciclagem, setPercVarPercReciclagem] = useState()
    var [percVarPercCompostagem, setPercVarPercCompostagem] = useState()

    var [destinoReciclaveisSecosOutros, setDestinosReciclaveisSecosOutros] = useState('')
    var [destinoReciclaveisUmidosOutros, setDestinoReciclaveisUmidosOutros] = useState('')


    var [frequenciaPesagem, setFrequenciaPesagem] = useState('')
    var [justificativaPesagemInterrompida, setJustificativaPesagemInterrompida] = useState('')

    var [auditoriaTratBio, setAuditoriaTratBio] = useState(false)
    var [auditoriaTratQui, setAuditoriaTratQui] = useState(false)
    var [auditoriaAterro, setAuditoriaAterro] = useState(false)
    var [auditoriaAterroPerig, setAuditoriaAterroPerig] = useState(false)
    var [auditoriaRecep, setAuditoriaRecep] = useState(false)
    var [auditoriaNaoRealiza, setAuditoriaNaoRealiza] = useState(false)

    
    function salvaDadosGestao() {

        var dataPost = {

            informacoesAdicionais: informacoesAdicionais,
            possuiComiteResiduos: possuiComiteResiduos,
            frequenciaReunioes: frequenciaReunioes,
            responsavelGerenciamento: responsavelGerenciamento,
            responsavelGerenciamentoTrabalha: responsavelGerenciamentoTrabalha,
            destinoReciclaveisSecos: destinoReciclaveisSecos,
            destinoReciclaveisUmidos: destinoReciclaveisUmidos,
            destinoSubgrupoA4: destinoSubgrupoA4,
            auditoriaEmpresaColetaExterna: auditoriaEmpresaColetaExterna,
            
            
            
            /*
            calculadoPercentual: calculadoPercentual,
            percPapel: percPapel,
            percTexteis: percTexteis,
            percAlimento: percAlimento,
            percMadeira: percMadeira,
            percJardim: percJardim,
            percFralda: percFralda,
            percBorrachaCouro: percBorrachaCouro,
            percLodoEsgoto: percLodoEsgoto,
            percOutros: percOutros,
            percVarGerResid: percVarGerResid,
            percVarGerGrupoA: percVarGerGrupoA,
            percVarGerGrupoB: percVarGerGrupoB,
            percVarGerGrupoD: percVarGerGrupoD,
            percVarGerGrupoE: percVarGerGrupoE,
            percVarPercReciclagem: percVarPercReciclagem,
            percVarPercCompostagem: percVarPercCompostagem,
            destinoReciclaveisSecosOutros: destinoReciclaveisSecosOutros,
            destinoReciclaveisUmidosOutros: destinoReciclaveisUmidosOutros,
            */

            frequenciaPesagem: frequenciaPesagem,
            justificativaPesagemInterrompida: justificativaPesagemInterrompida,

            auditoriaTratBio: auditoriaTratBio,
            auditoriaTratQui: auditoriaTratQui,
            auditoriaAterro: auditoriaAterro,
            auditoriaAterroPerig: auditoriaAterroPerig,
            auditoriaRecep: auditoriaRecep,
            auditoriaNaoRealiza: auditoriaNaoRealiza,

        }

        //console.log(dataPost)

        

        window.$.confirm({
			//icon: 'fa fa-question',
            theme: 'material',
            closeIcon: true,
            animation: 'scale',
            type: 'green',
		    title: 'Confirmação',
		    content: 'Confirma os dados?',
		    buttons: {
		        Sim: function () {

                    if (residuo_id) {

                        api.put(`residuosGestao/${residuo_id}`, dataPost).then((result) => {

                            //console.log(result.data)
                            window.toastr.success('Registro salvo com sucesso!')
                            //setAtualizacaoGestao(moment().format('YYYY-MM-DD HH:mm:ss'))

                        }).catch((err) => {

                            console.log(err.response)

                        })

                    } else {

                        api.post(`residuosGestao/${adesao_institucional_id}/${ano}`, dataPost).then((result) => {

                            //console.log(result.data)
                            setResiduo_id(result.data[0].residuo_id)
                            window.toastr.success('Registro salvo com sucesso!')
                            //setAtualizacaoGestao(moment().format('YYYY-MM-DD HH:mm:ss'))

                        }).catch((err) => {

                            console.log(err.response)

                        })

                    }

                },
		        Cancelar: function () {
		            //$.alert('Canceled!');
		        }

            },

        });

    }


    function carregaDados() {

        if (ano) {


            api.get(`residuosGestao/${adesao_institucional_id}/${ano}`).then((result) => {

                //console.log(result.data, '!!')
    
                var data = result.data[0]
    
                setFrequenciaPesagem(data.frequenciaPesagem)
                setJustificativaPesagemInterrompida(data.justificativaPesagemInterrompida)
                setPossuiComiteResiduos(data.possuiComiteResiduos == null ? false : data.possuiComiteResiduos)
                setFrequenciaReunioes(data.frequenciaReunioes)
                setResponsavelGerenciamento(data.responsavelGerenciamento)
                setResponsavelGerenciamentoTrabalha(data.responsavelGerenciamentoTrabalha)
                setInformacoesAdicionais(data.informacoesAdicionais)
                setDestinoReciclaveisSecos(data.destinoReciclaveisSecos)
                setDestinoReciclaveisUmidos(data.destinoReciclaveisUmidos)
                setDestinoSubgrupoA4(data.destinoSubgrupoA4)
                setAuditoriaEmpresaColetaExterna(data.auditoriaEmpresaColetaExterna == null ? false : data.auditoriaEmpresaColetaExterna)
                setAuditoriaTratBio(data.auditoriaTratBio == null ? false : data.auditoriaTratBio)
    
                setAuditoriaTratQui(data.auditoriaTratQui == null ? false : data.auditoriaTratQui)
                setAuditoriaAterro(data.auditoriaAterro == null ? false : data.auditoriaAterro)
                setAuditoriaAterroPerig(data.auditoriaAterroPerig == null ? false : data.auditoriaAterroPerig)
                setAuditoriaRecep(data.auditoriaRecep == null ? false : data.auditoriaRecep)

                setAuditoriaNaoRealiza(data.auditoriaNaoRealiza == null ? false : data.auditoriaNaoRealiza)

                setResiduo_id(data.residuo_id)
    
            }).catch((err) => {
    
                console.log(err.response)
    
            })

        }

        


    }


    useEffect(() => {

        //console.log(props.adesao_institucional_id, '!!')

        setAuditoriaTratBio(false)
        setAuditoriaEmpresaColetaExterna('')
        setDestinoSubgrupoA4('')
        setDestinoReciclaveisUmidos('')
        setDestinoReciclaveisSecos('')
        setInformacoesAdicionais('')
        setResponsavelGerenciamentoTrabalha('')
        setPossuiComiteResiduos(false)
        setResponsavelGerenciamento('')
        setFrequenciaReunioes('')
        setFrequenciaPesagem('')
        setJustificativaPesagemInterrompida('')
        
        setAuditoriaTratQui(false)
        setAuditoriaAterro(false)
        setAuditoriaAterroPerig(false)
        setAuditoriaRecep(false)
        setAuditoriaNaoRealiza(false)
        
        setResiduo_id()

        setQuestao1()
        setQuestao2()
        setQuestao3()
        setQuestao4()
        setQuestao5()
        setQuestao6()
        setQuestao7()
        setQuestao8()
        setQuestao9()
        setQuestao10()
        setQuestao11()

        carregaDados()
        
        


    }, [ano, adesao_institucional_id])


    useEffect(() => {

        verificaValidacoes()

    }, [residuo_id, formulario_id, verificaDesafio])


    const verificaValidacoes = () => {

        //console.log('verificado')

        setQuestao1()
        setQuestao2()
        setQuestao3()
        setQuestao4()
        setQuestao5()
        setQuestao6()
        setQuestao7()
        setQuestao8()
        setQuestao9()
        setQuestao10()
        setQuestao11()

        if (residuo_id) {

            var dataPost = {

                formulario_id: residuo_id,
                desafio: 'Resíduos',

            }

            api.post('desafioValidaVarios', dataPost).then((result) => {

                
                var data = result.data
                var totalErros = 0

                for (var k = 0; k < data.length; k++) {

                    if (data[k].status == 'Erro') {


                        switch (data[k].enunciado) {

                            case '1. Qual a frequência de pesagem de resíduos de sua instituição?':

                                setQuestao1('red')
                                totalErros = totalErros + 1
    
                            break

                            case '2. A instituição possui Comissão/Comitê/Grupo de trabalho que se reúne para discutir a gestão de resíduos?':

                                setQuestao2('red')
                                totalErros = totalErros + 1

                            break

                            case '3. Qual a frequência de reuniões da Comissão/Comitê/Grupo de trabalho para discutir sobre o gerenciamento de resíduos?':

                                setQuestao3('red')
                                totalErros = totalErros + 1

                            break

                            case '4. O responsável pelo gerenciamento de resíduos ocupa qual cargo na instituição?':

                                setQuestao4('red')
                                totalErros = totalErros + 1

                            break

                            case '5. O responsável pelo gerenciamento de resíduos trabalha:':

                                setQuestao5('red')
                                totalErros = totalErros + 1

                            break

                            case '6. Descreva as principais iniciativas implementadas pela instituição no processo de gestão de resíduos que vizem a redução dos impactos ambientais e incremento da sustentabilidade?':

                                setQuestao6('red')
                                totalErros = totalErros + 1

                            break

                            case '7. Qual o encaminhamento predominante dos resíduos recicláveis secos?':

                                setQuestao7('red')
                                totalErros = totalErros + 1

                            break

                            case '8. Qual o encaminhamento predominante dos resíduos orgânicos?':

                                setQuestao8('red')
                                totalErros = totalErros + 1

                            break

                            case '9. Na sua instituição os resíduos do Subgrupo A4 são destinados de forma separada dos outros resíduos do Grupo A? Art. 53 da RDC ANVISA 222/2018':

                                setQuestao9('red')
                                totalErros = totalErros + 1

                            break

                            case '10. Você realiza auditoria no serviço de tratamento e disposição final dos resíduos gerados em sua instituição?':

                                setQuestao10('red')
                                totalErros = totalErros + 1

                            break

                            case '11. A auditoria nos serviços de tratamento e disposição final contempla:':

                                setQuestao11('red')
                                totalErros = totalErros + 1

                            break
                        }

                    }

                    

                }

                setTotalPendencias(totalErros)

            }).catch((err) => {

                console.log(err.response)

            })

        }


    }


    return (

        <div>

                <div className="row">                               



                <div className="col-md-12">


                    <Table striped bordered hover>
                        
                        <tbody>
                            <tr>
                                <td style={{backgroundColor: '#e6f7ec'}} colspan="2">
                                <Link to='#' style={{ color: questao1 }} onClick={() => {setEnunciado('1. Qual a frequência de pesagem de resíduos de sua instituição?');setSecaoEnunciado('Dados Gestão');window.$('#modalValidacao').modal('show')}}>
                                    1. Qual a frequência de pesagem de resíduos de sua instituição?</Link>
                                </td>
                            </tr>
                            <tr>
                                <td style={{width: '120px'}}>
                                    <center>
                                    <input type="radio" name="frequenciaPesagem" onClick={() => setFrequenciaPesagem('D')} checked={ frequenciaPesagem == 'D' ? 1 : 0}  />
                                    </center>
                                </td>
                                <td>
                                    Diária
                                </td>
                                
                            </tr>

                            <tr>
                                <td style={{width: '120px'}}>
                                    <center>
                                    <input type="radio" name="frequenciaPesagem" onClick={() => setFrequenciaPesagem('1')} checked={ frequenciaPesagem == '1' ? 1 : 0}  />
                                    </center>
                                </td>
                                <td>
                                7 dias a cada m&ecirc;s
                                </td>
                                
                            </tr>

                            <tr>
                                <td style={{width: '120px'}}>
                                    <center>
                                    <input type="radio" name="frequenciaPesagem" onClick={() => setFrequenciaPesagem('2')} checked={ frequenciaPesagem == '2' ? 1 : 0}  />
                                    </center>
                                </td>
                                <td>
                                7 dias a cada dois meses
                                </td>
                                
                            </tr>

                            <tr>
                                <td style={{width: '120px'}}>
                                    <center>
                                    <input type="radio" name="frequenciaPesagem" onClick={() => setFrequenciaPesagem('3')} checked={ frequenciaPesagem == '3' ? 1 : 0}   />
                                    </center>
                                </td>
                                <td>
                                7 dias a cada tr&ecirc;s meses
                                </td>
                                
                            </tr>
                            
                            

                        </tbody>
                    </Table>


                </div>


                <div className="col-md-12">


                    <Table striped bordered hover>
                        
                        <tbody>
                            <tr>
                                <td style={{backgroundColor: '#e6f7ec'}} colspan="2">
                                Caso a pesagem de resíduos tenha sido interrompida durante o ano relato por um período maior que 36 dias, justifique no campo abaixo. Em caso negativo, favor escrever no campo abaixo "Não se aplica".
                                </td>
                            </tr>
                            <tr>
                                <td style={{width: '120px'}}>
                                    <center>
                                    <input className="form-control" type="text" onChange={event => setJustificativaPesagemInterrompida(event.target.value)} value={justificativaPesagemInterrompida}  />
                                    </center>
                                </td>
                                
                            </tr>

                          

                        </tbody>
                    </Table>


                </div>

                    

                   

                    <div className="col-md-12">


                        <Table striped bordered hover>
                            
                            <tbody>
                                <tr>
                                    <td style={{backgroundColor: '#e6f7ec'}} colspan="2">
                                    <Link to='#' style={{ color: questao2 }} onClick={() => {setEnunciado('2. A instituição possui Comissão/Comitê/Grupo de trabalho que se reúne para discutir a gestão de resíduos?');setSecaoEnunciado('Dados Gestão');window.$('#modalValidacao').modal('show')}}>
                                    2. A instituição possui Comissão/Comitê/Grupo de trabalho que se reúne para discutir a gestão de resíduos? *
                                    </Link>
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{width: '120px'}}>
                                        <center>
                                        <input type="radio" name="possuiComiteResiduos" onClick={() => setPossuiComiteResiduos(true)} checked={ possuiComiteResiduos ? 1 : 0}  />
                                        </center>
                                    </td>
                                    <td>
                                        Sim
                                    </td>
                                    
                                </tr>
                                <tr>
                                    <td style={{width: '120px'}}>
                                        <center>
                                        <input type="radio" name="possuiComiteResiduos"  onClick={() => setPossuiComiteResiduos(false)} checked={ !possuiComiteResiduos ? 1 : 0}  />
                                        </center>
                                    </td>
                                    <td>
                                    Não
                                    </td>
                                    
                                </tr>
                                
                                
     
                            </tbody>
                        </Table>


                    </div>


                    <div className="col-md-12">


                        <Table striped bordered hover>
                            
                            <tbody>
                                <tr>
                                    <td style={{backgroundColor: '#e6f7ec'}} colspan="2">
                                    <Link to='#' style={{ color: questao3 }} onClick={() => {setEnunciado('3. Qual a frequência de reuniões da Comissão/Comitê/Grupo de trabalho para discutir sobre o gerenciamento de resíduos?');setSecaoEnunciado('Dados Gestão');window.$('#modalValidacao').modal('show')}}>
                                    3. Qual a frequência de reuniões da Comissão/Comitê/Grupo de trabalho para discutir sobre o gerenciamento de resíduos? *
                                    </Link>
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{width: '120px'}}>
                                        <center>
                                        <input type="radio" name="frequenciaReunioes" onClick={() => setFrequenciaReunioes('M')} checked={ frequenciaReunioes == 'M' ? 1 : 0}  />
                                        </center>
                                    </td>
                                    <td>
                                    Mensal ou mais frequente
                                    </td>
                                    
                                </tr>
                                <tr>
                                    <td style={{width: '120px'}}>
                                        <center>
                                        <input type="radio" name="frequenciaReunioes" onClick={() => setFrequenciaReunioes('B')} checked={ frequenciaReunioes == 'B' ? 1 : 0}  />
                                        </center>
                                    </td>
                                    <td>
                                    Bimestral
                                    </td>
                                    
                                </tr>
                                <tr>
                                    <td style={{width: '120px'}}>
                                        <center>
                                        <input type="radio" name="frequenciaReunioes" onClick={() => setFrequenciaReunioes('T')} checked={ frequenciaReunioes == 'T' ? 1 : 0}  />
                                        </center>
                                    </td>
                                    <td>
                                    Trimestral
                                    </td>
                                    
                                </tr>
                                <tr>
                                    <td style={{width: '120px'}}>
                                        <center>
                                        <input type="radio" name="frequenciaReunioes" onClick={() => setFrequenciaReunioes('S')} checked={ frequenciaReunioes == 'S' ? 1 : 0}  />
                                        </center>
                                    </td>
                                    <td>
                                    Semestral
                                    </td>
                                    
                                </tr>
                                <tr>
                                    <td style={{width: '120px'}}>
                                        <center>
                                        <input type="radio" name="frequenciaReunioes"  onClick={() => setFrequenciaReunioes('A')} checked={ frequenciaReunioes == 'A' ? 1 : 0}  />
                                        </center>
                                    </td>
                                    <td>
                                    Anual
                                    </td>
                                    
                                </tr>
                                
                                
                                
     
                            </tbody>
                        </Table>


                    </div>


                    <div className="col-md-12">


                        <Table striped bordered hover>
                            
                            <tbody>
                                <tr>
                                    <td style={{backgroundColor: '#e6f7ec'}} colspan="2">
                                    <Link to='#' style={{ color: questao4 }} onClick={() => {setEnunciado('4. O responsável pelo gerenciamento de resíduos ocupa qual cargo na instituição?');setSecaoEnunciado('Dados Gestão');window.$('#modalValidacao').modal('show')}}>
                                    4. O responsável pelo gerenciamento de resíduos ocupa qual cargo na instituição? *
                                    </Link>
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{width: '120px'}}>
                                        <center>
                                        <input type="radio" name="responsavelGerenciamento" onClick={() => setResponsavelGerenciamento('N')} checked={ responsavelGerenciamento == 'N' ? 1 : 0}  />
                                        </center>
                                    </td>
                                    <td>
                                    Não possui responsável pelo gerenciamento de resíduos
                                    </td>
                                    
                                </tr>
                                <tr>
                                    <td style={{width: '120px'}}>
                                        <center>
                                        <input type="radio" name="responsavelGerenciamento" onClick={() => setResponsavelGerenciamento('T')} checked={ responsavelGerenciamento == 'T' ? 1 : 0}  />
                                        </center>
                                    </td>
                                    <td>
                                    Nível técnico / operacional
                                    </td>
                                    
                                </tr>
                                <tr>
                                    <td style={{width: '120px'}}>
                                        <center>
                                        <input type="radio" name="responsavelGerenciamento" onClick={() => setResponsavelGerenciamento('G')} checked={ responsavelGerenciamento == 'G' ? 1 : 0}  />
                                        </center>
                                    </td>
                                    <td>
                                    Nível gerencial / chefia
                                    </td>
                                    
                                </tr>
                                
     
                            </tbody>
                        </Table>


                    </div>


                    <div className="col-md-12">


                        <Table striped bordered hover>
                            
                            <tbody>
                                <tr>
                                    <td style={{backgroundColor: '#e6f7ec'}} colspan="2">
                                    <Link to='#' style={{ color: questao5 }} onClick={() => {setEnunciado('5. O responsável pelo gerenciamento de resíduos trabalha:');setSecaoEnunciado('Dados Gestão');window.$('#modalValidacao').modal('show')}}>
                                    5. O responsável pelo gerenciamento de resíduos trabalha: *
                                    </Link>
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{width: '120px'}}>
                                        <center>
                                        <input type="radio" name="responsavelGerenciamentoTrabalha" onClick={() => setResponsavelGerenciamentoTrabalha('E')} checked={ responsavelGerenciamentoTrabalha == 'E' ? 1 : 0}  />
                                        </center>
                                    </td>
                                    <td>
                                    Exclusivo no gerenciamento de resíduos
                                    </td>
                                    
                                </tr>
                                <tr>
                                    <td style={{width: '120px'}}>
                                        <center>
                                        <input type="radio" name="responsavelGerenciamentoTrabalha" onClick={() => setResponsavelGerenciamentoTrabalha('T')} checked={ responsavelGerenciamentoTrabalha == 'T' ? 1 : 0}  />
                                        </center>
                                    </td>
                                    <td>
                                    Gerenciamento de resíduos junto com saúde e segurança do trabalho
                                    </td>
                                    
                                </tr>
                                <tr>
                                    <td style={{width: '120px'}}>
                                        <center>
                                        <input type="radio" name="responsavelGerenciamentoTrabalha"  onClick={() => setResponsavelGerenciamentoTrabalha('O')} checked={ responsavelGerenciamentoTrabalha == 'O' ? 1 : 0}  />
                                        </center>
                                    </td>
                                    <td>
                                    Gerenciamento de resíduos junto com outras atividades operacionais
                                    </td>
                                    
                                </tr>
                                <tr>
                                    <td style={{width: '120px'}}>
                                        <center>
                                        <input type="radio" name="responsavelGerenciamentoTrabalha"  onClick={() => setResponsavelGerenciamentoTrabalha('N')} checked={ responsavelGerenciamentoTrabalha == 'N' ? 1 : 0}  />
                                        </center>
                                    </td>
                                    <td>
                                    Não possui responsável pelo gerenciamento de resíduos
                                    </td>
                                    
                                </tr>
                                
     
                            </tbody>
                        </Table>


                    </div>


                    <div className="col-md-12">
                        <br/>
                        Utilize o campo abaixo para fornecer informações adicionais sobre as iniciativas de gestão de resíduos. Essas informações são importantes para a divulgação dos trabalhos da instituição.
                        <br/><br/>

                    </div>

                    <div className="col-md-12">

                        <Table striped bordered hover>
                            
                            <tbody>
                                <tr>
                                    <td style={{backgroundColor: '#e6f7ec'}} colspan="2">
                                    <Link to='#' style={{ color: questao6 }} onClick={() => {setEnunciado('6. Descreva as principais iniciativas implementadas pela instituição no processo de gestão de resíduos que vizem a redução dos impactos ambientais e incremento da sustentabilidade?');setSecaoEnunciado('Dados Gestão');window.$('#modalValidacao').modal('show')}}>
                                    6. Descreva as principais iniciativas implementadas pela instituição no processo de gestão de resíduos que vizem a redução dos impactos ambientais e incremento da sustentabilidade? *
                                    </Link>
                                    </td>
                                </tr>
                                <td>
                                    <textarea class="form-control" rows="5" maxlength="800" value={informacoesAdicionais} onChange={event => setInformacoesAdicionais(event.target.value)} />
                                </td>
                            </tbody>

                        </Table>



                    </div>




                    <div className="col-md-12">


                        <Table striped bordered hover>
                            
                            <tbody>
                                <tr>
                                    <td style={{backgroundColor: '#e6f7ec'}} colspan="2">
                                    <Link to='#' style={{ color: questao7 }} onClick={() => {setEnunciado('7. Qual o encaminhamento predominante dos resíduos recicláveis secos?');setSecaoEnunciado('Dados Gestão');window.$('#modalValidacao').modal('show')}}>
                                    7. Qual o encaminhamento predominante dos resíduos recicláveis secos?
                                    </Link>                                    
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{width: '120px'}}>
                                        <center>
                                        <input type="radio" name="destinoReciclaveisSecos" onClick={() => setDestinoReciclaveisSecos('D')} checked={ destinoReciclaveisSecos == 'D' ? 1 : 0}  />
                                        </center>
                                    </td>
                                    <td>
                                    Doação
                                    </td>
                                    
                                </tr>
                                
                                <tr>
                                    <td style={{width: '120px'}}>
                                        <center>
                                        <input type="radio" name="destinoReciclaveisSecos" onClick={() => setDestinoReciclaveisSecos('E')} checked={ destinoReciclaveisSecos == 'E' ? 1 : 0}  />
                                        </center>
                                    </td>
                                    <td>
                                    Entregue para serviço municipal
                                    </td>
                                    
                                </tr>
                                <tr>
                                    <td style={{width: '120px'}}>
                                        <center>
                                        <input type="radio" name="destinoReciclaveisSecos" onClick={() => setDestinoReciclaveisSecos('V')} checked={ destinoReciclaveisSecos == 'V' ? 1 : 0}  />
                                        </center>
                                    </td>
                                    <td>
                                    Venda
                                    </td>
                                    
                                </tr>
                                <tr>
                                    <td style={{width: '120px'}}>
                                        <center>
                                        <input type="radio" name="destinoReciclaveisSecos" onClick={() => setDestinoReciclaveisSecos('N')} checked={ destinoReciclaveisSecos == 'N' ? 1 : 0}  />
                                        </center>
                                    </td>
                                    <td>
                                    Não realizamos coleta seletiva dos resíduos secos.
                                    </td>
                                    
                                </tr>

                                <tr style={{ display: 'none'}}>
                                    <td style={{width: '120px'}}>
                                        <center>
                                        <input type="radio" name="destinoReciclaveisSecos" onClick={() => setDestinoReciclaveisSecos('O')} checked={ destinoReciclaveisSecos == 'O' ? 1 : 0}   />
                                        </center>
                                    </td>
                                    <td>
                                    Outra opção
                                    </td>
                                    
                                </tr>
                                <tr style={{ display: destinoReciclaveisSecos == 'O' ? 'table-row' : 'none' }}>
                                    <td colspan="2">
                                        <input className='form-control' maxlength="255" value={destinoReciclaveisSecosOutros} placeholder="Informe..." onChange={event => setDestinosReciclaveisSecosOutros(event.target.value)} disabled />
                                    </td>
                                </tr>
                                
                                
     
                            </tbody>
                        </Table>


                    </div>




                    <div className="col-md-12">


                        <Table striped bordered hover>
                            
                            <tbody>
                                <tr>
                                    <td style={{backgroundColor: '#e6f7ec'}} colspan="2">
                                    <Link to='#' style={{ color: questao8 }} onClick={() => {setEnunciado('8. Qual o encaminhamento predominante dos resíduos orgânicos?');setSecaoEnunciado('Dados Gestão');window.$('#modalValidacao').modal('show')}}>
                                    8. Qual o encaminhamento predominante dos resíduos orgânicos?
                                    </Link>
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{width: '120px'}}>
                                        <center>
                                        <input type="radio" name="destinoReciclaveisUmidos" onClick={() => setDestinoReciclaveisUmidos('D')} checked={ destinoReciclaveisUmidos == 'D' ? 1 : 0}   />
                                        </center>
                                    </td>
                                    <td>
                                    Doação para compostagem (Cooperativas/Associações de catadores);
                                    </td>
                                    
                                </tr>
                                <tr>
                                    <td style={{width: '120px'}}>
                                        <center>
                                        <input type="radio" name="destinoReciclaveisUmidos" onClick={() => setDestinoReciclaveisUmidos('E')} checked={ destinoReciclaveisUmidos == 'E' ? 1 : 0}   />
                                        </center>
                                    </td>
                                    <td>
                                    Entregue para o serviço municipal realizar a compostagem;
                                    </td>
                                    
                                </tr>

                                <tr>
                                    <td style={{width: '120px'}}>
                                        <center>
                                        <input type="radio" name="destinoReciclaveisUmidos" onClick={() => setDestinoReciclaveisUmidos('P')} checked={ destinoReciclaveisUmidos == 'P' ? 1 : 0}   />
                                        </center>
                                    </td>
                                    <td>
                                    Composto em área do próprio estabelecimento;
                                    </td>
                                    
                                </tr>
                                <tr>
                                    <td style={{width: '120px'}}>
                                        <center>
                                        <input type="radio" name="destinoReciclaveisUmidos" onClick={() => setDestinoReciclaveisUmidos('F')} checked={ destinoReciclaveisUmidos == 'F' ? 1 : 0}   />
                                        </center>
                                    </td>
                                    <td>
                                    Coletados por empresa contatada para realização da compostagem fora das instalações da unidade.
                                    </td>
                                    
                                </tr>


                                <tr>
                                    <td style={{width: '120px'}}>
                                        <center>
                                        <input type="radio" name="destinoReciclaveisUmidos" onClick={() => setDestinoReciclaveisUmidos('B')} checked={ destinoReciclaveisUmidos == 'B' ? 1 : 0}  />
                                        </center>
                                    </td>
                                    <td>
                                    Biodigestores no próprio estabelecimento.
                                    </td>
                                    
                                </tr>


                                <tr>
                                    <td style={{width: '120px'}}>
                                        <center>
                                        <input type="radio" name="destinoReciclaveisUmidos" onClick={() => setDestinoReciclaveisUmidos('S')} checked={ destinoReciclaveisUmidos == 'S' ? 1 : 0}  />
                                        </center>
                                    </td>
                                    <td>
                                    Envio para engorda de suínos.
                                    </td>
                                    
                                </tr>

                                

                                <tr >
                                    <td style={{width: '120px'}}>
                                        <center>
                                        <input type="radio" name="destinoReciclaveisUmidos" onClick={() => setDestinoReciclaveisUmidos('N')} checked={ destinoReciclaveisUmidos == 'N' ? 1 : 0}  />
                                        </center>
                                    </td>
                                    <td>
                                    Não há destinação diferenciada para os resíduos orgânicos
                                    </td>
                                    
                                </tr>
                                
                                <tr style={{ display: 'none'}}>
                                    <td style={{width: '120px'}}>
                                        <center>
                                        <input type="radio" name="destinoReciclaveisUmidos" onClick={() => setDestinoReciclaveisUmidos('O')} checked={ destinoReciclaveisUmidos == 'O' ? 1 : 0}  />
                                        </center>
                                    </td>
                                    <td>
                                    Outra opção
                                    </td>
                                    
                                </tr>
                                <tr style={{ display: destinoReciclaveisUmidos == 'O' ? 'table-row' : 'none' }}>
                                    <td colspan="2">
                                        <input className='form-control' maxlength="255" value={destinoReciclaveisUmidosOutros} placeholder="Informe..." onChange={event => setDestinoReciclaveisUmidosOutros(event.target.value)} disabled />
                                    </td>
                                </tr>
                                
     
                            </tbody>
                        </Table>


                    </div>




                    <div className="col-md-12">


                        <Table striped bordered hover>
                            
                            <tbody>
                                <tr>
                                    <td style={{backgroundColor: '#e6f7ec'}} colspan="2">
                                    <Link to='#' style={{ color: questao9 }} onClick={() => {setEnunciado('9. Na sua instituição os resíduos do Subgrupo A4 são destinados de forma separada dos outros resíduos do Grupo A? Art. 53 da RDC ANVISA 222/2018');setSecaoEnunciado('Dados Gestão');window.$('#modalValidacao').modal('show')}}>
                                    9. Na sua instituição os resíduos do Subgrupo A4 são destinados de forma separada dos outros resíduos do Grupo A? Art. 53 da RDC ANVISA 222/2018
                                    </Link>
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{width: '120px'}}>
                                        <center>
                                        <input type="radio" name="destinoSubgrupoA4" onClick={() => setDestinoSubgrupoA4('A')} checked={ destinoSubgrupoA4 == 'A' ? 1 : 0}  />
                                        </center>
                                    </td>
                                    <td>
                                    Sim, enviamos para aterro sanitário sem tratamento prévio, conforme autorizado no artigo.
                                    </td>
                                    
                                </tr>
                                <tr style={{ display: 'none'}}>
                                    <td style={{width: '120px'}}>
                                        <center>
                                        <input type="radio" name="destinoSubgrupoA4" onClick={() => setDestinoSubgrupoA4('T')} checked={ destinoSubgrupoA4 == 'T' ? 1 : 0}  />
                                        </center>
                                    </td>
                                    <td>
                                    Tratamento juntamente com os outros tipos de resíduos do Grupo A 
                                    </td>
                                    
                                </tr>
                                <tr>
                                    <td style={{width: '120px'}}>
                                        <center>
                                        <input type="radio" name="destinoSubgrupoA4" onClick={() => setDestinoSubgrupoA4('N')} checked={ destinoSubgrupoA4 == 'N' ? 1 : 0}  />
                                        </center>
                                    </td>
                                    <td>
                                    Não, enviamos para tratamento juntamente com os outros tipos de resíduos do Grupo A.
                                    </td>
                                    
                                </tr>
                                
                                
     
                            </tbody>
                        </Table>


                    </div>



                    <div className="col-md-12">


                        <Table striped bordered hover>
                            
                            <tbody>
                                <tr>
                                    <td style={{backgroundColor: '#e6f7ec'}} colspan="2">
                                    <Link to='#' style={{ color: questao10 }} onClick={() => {setEnunciado('10. Você realiza auditoria no serviço de tratamento e disposição final dos resíduos gerados em sua instituição?');setSecaoEnunciado('Dados Gestão');window.$('#modalValidacao').modal('show')}}>
                                    10. Você realiza auditoria no serviço de tratamento e disposição final dos resíduos gerados em sua instituição?
                                    </Link>
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{width: '120px'}}>
                                        <center>
                                        <input type="radio" name="auditoriaEmpresaColetaExterna" onClick={() => setAuditoriaEmpresaColetaExterna('S')} checked={ auditoriaEmpresaColetaExterna == 'S' ? 1 : 0}  />
                                        </center>
                                    </td>
                                    <td>
                                    Sim, no momento da contratação;
                                    </td>
                                    
                                </tr>
                                <tr>
                                    <td style={{width: '120px'}}>
                                        <center>
                                        <input type="radio" name="auditoriaEmpresaColetaExterna" onClick={() => setAuditoriaEmpresaColetaExterna('A')} checked={ auditoriaEmpresaColetaExterna == 'A' ? 1 : 0}  />
                                        </center>
                                    </td>
                                    <td>
                                    Sim, uma vez por ano;
                                    </td>
                                    
                                </tr>
                                <tr>
                                    <td style={{width: '120px'}}>
                                        <center>
                                        <input type="radio" name="auditoriaEmpresaColetaExterna" onClick={() => setAuditoriaEmpresaColetaExterna('D')} checked={ auditoriaEmpresaColetaExterna == 'D' ? 1 : 0}  />
                                        </center>
                                    </td>
                                    <td>
                                    Sim, duas ou mais vezes por ano;
                                    </td>
                                    
                                </tr>
                                <tr>
                                    <td style={{width: '120px'}}>
                                        <center>
                                        <input type="radio" name="auditoriaEmpresaColetaExterna" onClick={() => setAuditoriaEmpresaColetaExterna('N')} checked={ auditoriaEmpresaColetaExterna == 'N' ? 1 : 0}   />
                                        </center>
                                    </td>
                                    <td>
                                    Não realizamos auditoria.
                                    </td>
                                    
                                </tr>
                                
                                
     
                            </tbody>
                        </Table>


                    </div>




                    
                    <div className="col-md-12" style={{ display: auditoriaEmpresaColetaExterna != '' && auditoriaEmpresaColetaExterna != null  && auditoriaEmpresaColetaExterna != 'N' ? 'table-row' : 'none'}}>


                        <Table striped bordered hover>
                            
                            <tbody>
                                <tr>
                                    <td style={{backgroundColor: '#e6f7ec'}} colspan="2">
                                    <Link to='#' style={{ color: questao11 }} onClick={() => {setEnunciado('11. A auditoria nos serviços de tratamento e disposição final contempla:');setSecaoEnunciado('Dados Gestão');window.$('#modalValidacao').modal('show')}}>
                                    11. A auditoria nos serviços de tratamento e disposição final contempla:
                                    </Link>
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{width: '120px'}}>
                                        <center>
                                        
                                        <input type="checkbox" onChange={event => setAuditoriaTratBio(event.target.checked)} checked={ auditoriaTratBio ? 1 : 0}  />
                                        </center>
                                    </td>
                                    <td>
                                    Tratamentos de resíduos biológicos
                                    </td>
                                    
                                </tr>
                                <tr>
                                    <td style={{width: '120px'}}>
                                        <center>
                                        
                                        <input type="checkbox" onChange={event => setAuditoriaTratQui(event.target.checked)} checked={ auditoriaTratQui ? 1 : 0}  />
                                        </center>
                                    </td>
                                    <td>
                                    Tratamento de resíduos químicos
                                    </td>
                                    
                                </tr>
                                <tr>
                                    <td style={{width: '120px'}}>
                                        <center>
                                        
                                        <input type="checkbox" onChange={event => setAuditoriaAterro(event.target.checked)} checked={ auditoriaAterro ? 1 : 0}  />
                                        </center>
                                    </td>
                                    <td>
                                    Aterro sanitários para resíduos comuns
                                    </td>
                                    
                                </tr>
                                <tr>
                                    <td style={{width: '120px'}}>
                                        <center>
                                        
                                        <input type="checkbox" onChange={event => setAuditoriaAterroPerig(event.target.checked)} checked={ auditoriaAterroPerig ? 1 : 0}  />
                                        </center>
                                    </td>
                                    <td>
                                    Aterro sanitários para resíduos perigosos (Classe I)
                                    </td>
                                    
                                </tr>
                                <tr>
                                    <td style={{width: '120px'}}>
                                        <center>
                                        <input type="checkbox" onChange={event => setAuditoriaRecep(event.target.checked)} checked={ auditoriaRecep ? 1 : 0 } />
                                        </center>
                                    </td>
                                    <td>
                                    Recepção/triagem dos recicláveis
                                    </td>
                                    
                                </tr>
                                <tr style={{ display: 'none' }}>
                                    <td style={{width: '120px'}}>
                                        <center>
                                        <input type="checkbox" onChange={event => setAuditoriaNaoRealiza(event.target.checked)} checked={ auditoriaNaoRealiza ? 1 : 0}/>
                                        </center>
                                    </td>
                                    <td>
                                    Não realizamos auditoria
                                    </td>
                                    
                                </tr>
                                
                                
     
                            </tbody>
                        </Table>

                        <br/>
                        <center>
                        <button type="button" class="btn btn-primary" onClick={() => salvaDadosGestao()}>Salvar</button>
                        </center>


                    </div>


                
                    

                </div>


                <StatusValidacaoSecao desafio="Resíduos" secaoCampo="secaoGestao" totalPendencias={totalPendencias} nomeDesafio="Desafio Resíduos" formulario_id={residuo_id} secao="Gestão" adesao_institucional_id={adesao_institucional_id} ano={ano} />
                

        </div>
    )

}

export default DadosGestao